// @ts-strict-ignore
import keyBy from 'lodash/keyBy';

import {featureFlagsApi} from 'apps/feature-flags/src/api/feature-flags';
import type {FeatureFlagApiResponse} from 'app_api/projects/feature_flags/types';
import {BaseClient} from 'common/report/queries/utils/base-client';

import {Store} from './store';

/**
 * Simple client wrapper for the feature flags API to work with the Store pattern
 */
class FeatureFlagDefinitionsClient extends BaseClient {
  getUrl() {
    return ``;
  }

  buildEndpoint() {
    return ``;
  }

  processResponse(response) {
    return response;
  }

  async query(params: {projectId: string | number; workspaceId?: string | number}) {
    const api = featureFlagsApi({projectId: params.projectId, workspaceId: params.workspaceId});
    return api.listFeatureFlags();
  }
}

function getFeatureFlagDefinitionKey(featureFlag: FeatureFlagApiResponse) {
  return featureFlag.key;
}

export const transform = {
  index: (definitions: FeatureFlagApiResponse[]) => keyBy(definitions, getFeatureFlagDefinitionKey),
  update: (definition: FeatureFlagApiResponse) => ({k: getFeatureFlagDefinitionKey(definition), v: definition}),
};

const client = new FeatureFlagDefinitionsClient();

export const featureFlagDefinitionsStore = new Store<
  {[featureFlagKey: string]: FeatureFlagApiResponse},
  FeatureFlagApiResponse[]
>({
  apiClient: client as BaseClient,
  defaultValue: {},
  name: `feature-flag-definitions`,
  transform,
});

export type FeatureFlagDefinitionsStore = typeof featureFlagDefinitionsStore;

export function findFeatureFlagDefinitionByDisplayName(displayName: string) {
  return Object.values(featureFlagDefinitionsStore.value).find((item) => item.name === displayName);
}
